import { Card } from "reactstrap";
import { SERVICE_TABS } from "../../../../constant/constant";

// VIDEOGRAPHY PROJECT STATUS OBJ
export const VIDEOGRAPHY_PROJECT_STATUS_OBJ = {
  REQUESTED: "requested",
  FOOTAGE_RECEIVED: "footage_received",
  ASSIGNED_TO_EDITOR: "assigned_to_editor",
  EDITING_IN_PROGRESS: "editing_in_progress",
  REVISION_IN_PROGRESS: "revision_in_progress",
  EDIT_COMPLETE: "edit_complete",
  APPROVED_BY_CLIENT: "approved_by_client",
};

export const VIDEOGRAPHY_PROJECT_LABEL_BY_STATUS = {
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.REQUESTED]: "Requested",
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.FOOTAGE_RECEIVED]: "Footage Received",
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.ASSIGNED_TO_EDITOR]: "Assigned to Editor",
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.EDITING_IN_PROGRESS]: "Editing in Progress",
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.REVISION_IN_PROGRESS]: "Revision in Progress",
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.EDIT_COMPLETE]: "Edit Complete",
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.APPROVED_BY_CLIENT]: "Approved by Client",
};

export const VIDEOGRAPHY_PROJECT_STATUS_OPTIONS = [
  {
    value: VIDEOGRAPHY_PROJECT_STATUS_OBJ.REQUESTED,
    label: "Project Requested",
  },
  {
    value: VIDEOGRAPHY_PROJECT_STATUS_OBJ.FOOTAGE_RECEIVED,
    label: "Footage Received",
  },
  {
    value: VIDEOGRAPHY_PROJECT_STATUS_OBJ.ASSIGNED_TO_EDITOR,
    label: "Assigned to Editor",
  },
  {
    value: VIDEOGRAPHY_PROJECT_STATUS_OBJ.EDITING_IN_PROGRESS,
    label: "Editing in Progress",
  },
  {
    value: VIDEOGRAPHY_PROJECT_STATUS_OBJ.REVISION_IN_PROGRESS,
    label: "Revision in Progress",
  },
  {
    value: VIDEOGRAPHY_PROJECT_STATUS_OBJ.EDIT_COMPLETE,
    label: "Edit Complete",
  },
  {
    value: VIDEOGRAPHY_PROJECT_STATUS_OBJ.APPROVED_BY_CLIENT,
    label: "Approved",
  },
];

export const VIDEOGRAPHY_PROJECT_STATUS_FILTERED_OPTIONS =
  VIDEOGRAPHY_PROJECT_STATUS_OPTIONS.filter(
    (a) => a.value !== VIDEOGRAPHY_PROJECT_STATUS_OBJ.APPROVED_BY_CLIENT
  );

export const VIDEOGRAPHY_PROJECT_STATUS_VALUES = Object.values(
  VIDEOGRAPHY_PROJECT_STATUS_OBJ
);

export const VIDEOGRAPHY_PROJECT_STATUS_COLOR_CODE = new Map([
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.REQUESTED, "#A29BFE"],
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.FOOTAGE_RECEIVED, "#81AED0"],
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.ASSIGNED_TO_EDITOR, "#7DC4B8"],
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.EDITING_IN_PROGRESS, "#E69A6E"],
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.REVISION_IN_PROGRESS, "#D07A8A"],
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.EDIT_COMPLETE, "#A8C49A"],
  [VIDEOGRAPHY_PROJECT_STATUS_OBJ.APPROVED_BY_CLIENT, "#88B67A"],
]);

// PHOTOGRAPHY PROJECT STATUS OBJ
export const PHOTOGRAPHY_PROJECT_STATUS_OBJ = {
  REQUESTED: "requested",
  FOOTAGE_RECEIVED: "footage_received",
  ASSIGNED_TO_EDITOR: "assigned_to_editor",
  EDITING_IN_PROGRESS: "editing_in_progress",
  REVISION_IN_PROGRESS: "revision_in_progress",
  EDIT_COMPLETE: "edit_complete",
  APPROVED_BY_CLIENT: "approved_by_client",
};

export const PHOTOGRAPHY_PROJECT_LABEL_BY_STATUS = {
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.REQUESTED]: "Requested",
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.FOOTAGE_RECEIVED]: "Photos Received",
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.ASSIGNED_TO_EDITOR]: "Assigned to Editor",
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.EDITING_IN_PROGRESS]: "Editing in Progress",
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.REVISION_IN_PROGRESS]: "Revision in Progress",
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.EDIT_COMPLETE]: "Edit Complete",
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.APPROVED_BY_CLIENT]: "Approved by Client",
};

export const PHOTOGRAPHY_PROJECT_STATUS_OPTIONS = [
  {
    value: PHOTOGRAPHY_PROJECT_STATUS_OBJ.REQUESTED,
    label: "Project Requested",
  },
  {
    value: PHOTOGRAPHY_PROJECT_STATUS_OBJ.FOOTAGE_RECEIVED,
    label: "Photos Received",
  },
  {
    value: PHOTOGRAPHY_PROJECT_STATUS_OBJ.ASSIGNED_TO_EDITOR,
    label: "Assigned to Editor",
  },
  {
    value: PHOTOGRAPHY_PROJECT_STATUS_OBJ.EDITING_IN_PROGRESS,
    label: "Editing in Progress",
  },
  {
    value: PHOTOGRAPHY_PROJECT_STATUS_OBJ.REVISION_IN_PROGRESS,
    label: "Revision in Progress",
  },
  {
    value: PHOTOGRAPHY_PROJECT_STATUS_OBJ.EDIT_COMPLETE,
    label: "Edit Complete",
  },
  {
    value: PHOTOGRAPHY_PROJECT_STATUS_OBJ.APPROVED_BY_CLIENT,
    label: "Approved",
  },
];

export const PHOTOGRAPHY_PROJECT_STATUS_FILTERED_OPTIONS =
  PHOTOGRAPHY_PROJECT_STATUS_OPTIONS.filter(
    (a) => a.value !== PHOTOGRAPHY_PROJECT_STATUS_OBJ.APPROVED_BY_CLIENT
  );

export const PHOTOGRAPHY_PROJECT_STATUS_VALUES = Object.values(
  PHOTOGRAPHY_PROJECT_STATUS_OBJ
);

export const PHOTOGRAPHY_PROJECT_STATUS_COLOR_CODE = new Map([
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.REQUESTED, "#A29BFE"],
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.FOOTAGE_RECEIVED, "#81AED0"],
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.ASSIGNED_TO_EDITOR, "#7DC4B8"],
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.EDITING_IN_PROGRESS, "#E69A6E"],
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.REVISION_IN_PROGRESS, "#D07A8A"],
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.EDIT_COMPLETE, "#A8C49A"],
  [PHOTOGRAPHY_PROJECT_STATUS_OBJ.APPROVED_BY_CLIENT, "#88B67A"],
]);

const EMPTY_STATUS_DATA = {
  STATUS_OBJ: {},
  STATUS_OPTIONS: [],
  STATUS_FILTERED_OPTIONS: [],
  STATUS_VALUES: [],
  STATUS_COLOR_CODE: new Map(),
  LABEL_BY_STATUS: {},
};

export const getProjectStatusDataByService = (service = SERVICE_TABS.video) => {
  const SERVICE_STATUS_MAP = {
    [SERVICE_TABS.video]: {
      STATUS_OBJ: VIDEOGRAPHY_PROJECT_STATUS_OBJ,
      STATUS_OPTIONS: VIDEOGRAPHY_PROJECT_STATUS_OPTIONS,
      STATUS_FILTERED_OPTIONS: VIDEOGRAPHY_PROJECT_STATUS_FILTERED_OPTIONS,
      STATUS_VALUES: VIDEOGRAPHY_PROJECT_STATUS_VALUES,
      STATUS_COLOR_CODE: VIDEOGRAPHY_PROJECT_STATUS_COLOR_CODE,
      LABEL_BY_STATUS: VIDEOGRAPHY_PROJECT_LABEL_BY_STATUS,
    },
    [SERVICE_TABS.photo]: {
      STATUS_OBJ: PHOTOGRAPHY_PROJECT_STATUS_OBJ,
      STATUS_OPTIONS: PHOTOGRAPHY_PROJECT_STATUS_OPTIONS,
      STATUS_FILTERED_OPTIONS: PHOTOGRAPHY_PROJECT_STATUS_FILTERED_OPTIONS,
      STATUS_VALUES: PHOTOGRAPHY_PROJECT_STATUS_VALUES,
      STATUS_COLOR_CODE: PHOTOGRAPHY_PROJECT_STATUS_COLOR_CODE,
      LABEL_BY_STATUS: PHOTOGRAPHY_PROJECT_LABEL_BY_STATUS,
    },
  };

  return SERVICE_STATUS_MAP[service] || EMPTY_STATUS_DATA;
};

export const projectTitle = (sub_order_key, productMappedList) => {
  if (Array.isArray(productMappedList) && typeof sub_order_key === "string") {
    return (
      productMappedList.find((option) => option.value === sub_order_key.trim())
        ?.label || "--"
    );
  }
  return "--";
};

export const TruncatedTextDiv = ({ initialText }) => {
  return (
    <div className="truncated-button">
      <span className="text">{initialText}</span>
    </div>
  );
};

export const reorderColumn = (draggedColumnId, targetColumnId, columnOrder) => {
  columnOrder.splice(
    columnOrder.indexOf(targetColumnId),
    0,
    columnOrder.splice(columnOrder.indexOf(draggedColumnId), 1)[0]
  );
  return [...columnOrder];
};

export const ProjectTypesLabels = [
  ["insta_video", "Instagram video"],
  ["highlight_video", "Music Highlight Video - Music only"],
  ["narrative_highlight_video", "Narrative Highlight video - Music + Dialogue"],
  ["cinematic_film", "Cinematic Feature Film - Music + Dialogue"],
  ["documentary_edits", "Documentary edits"],
];

export const NoDataFound = (text, error) => (
  <div className="no_data">
    <Card
      style={{
        marginBottom: "8px",
        ...(error && {
          color: "rgb(234, 84, 85)",
          border: "1px solid rgb(234, 84, 85)",
        }),
      }}
    >
      <p>{text || "No Data Found"}</p>
    </Card>
  </div>
);
